<template>
  <a-modal :title="title" :visible="open" :maskClosable="false" :keyboard="false" @cancel="importExcelHandleCancel"
    @ok="importExcelHandleChange" :width="1000">
    <a-spin tip="上传中..." :spinning="uploading">

      <!-- 上面一行：视频导入 -->
      <a-card title="剧集导入" style="width: 100%">
        <a-upload-dragger name="file" accept=".mp4" :multiple="true" :show-upload-list="false"
          :customRequest="handleChange" @change="changeFile">
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          <div>
            <font style="color: red">
              视频文件名和字幕文件名中间集数保持一致，例如：测试.1.mp4, 测试.1.中文.srt
            </font>
          </div>
          </p>
        </a-upload-dragger>

        <!-- 视频文件列表，加滚动条 -->
        <div style="margin-top: 10px; margin-bottom: 10px; max-height: 300px; overflow-y: auto;">
          <div v-for="(item, index) in fileList" :key="index" style="margin-bottom: 5px;">
            <div style="width: 100%; display: flex; justify-content: space-between; align-items: center;">
              <div>
                <a-icon type="loading" v-if="item.percent != 100" style="margin-right: 10px" />
                <a-icon type="link" v-if="item.percent == 100" style="margin-right: 10px" />
                {{ item.name }}
              </div>
              <div>
                <a-button v-if="item.percent === 100 && item.url" type="link" size="small" @click="openPreview(item)">
                  预览
                </a-button>
                <a-icon type="delete" @click.stop="clickDelete(index, 1)" />
              </div>
            </div>
            <a-progress style="height: 2px" v-if="item.percent != 100" :percent="item.percent" :show-info="false" />
          </div>
        </div>
      </a-card>

      <a-row :gutter="16" style="margin-top: 16px;">
        <!-- 第一行：中文字幕、英文字幕、日语字幕 -->
        <a-col :span="8">
          <a-card title="中文字幕">
            <a-upload-dragger name="file" accept=".srt,.vtt" :multiple="true" :show-upload-list="false"
              :customRequest="handleChangeZh">
              <p class="ant-upload-drag-icon"><a-icon type="inbox" /> 上传中文字幕</p>
            </a-upload-dragger>

            <div style="margin-top: 10px;margin-bottom: 10px">
              <a-card>
                <a-row type="flex">
                  <a-statistic title="总计" :value="fileZhList.length" />
                  <a-statistic title="正在上传" :value="computedUploadZhing" :style="{ margin: '0 32px' }"
                    :value-style="{ color: '#cf1322' }" />
                </a-row>
              </a-card>
            </div>

            <div style="max-height: 220px; overflow-y: auto;">
              <div v-for="(item, index) in fileZhList" :key="index" style="margin-bottom: 5px">
                <div style="display: flex; justify-content: space-between">
                  <div>
                    <a-icon type="loading" v-if="item.percent != 100" style="margin-right: 10px" />
                    <a-icon type="link" v-if="item.percent == 100" style="margin-right: 10px" />
                    <a-icon type="close-circle" v-if="item.status === 'error'" style="margin-right: 10px; color: #f5222d" />
                    {{ item.name }}
                  </div>
                  <a-icon type="delete" @click.stop="clickDelete(index, 2)" />
                </div>
                <a-progress v-if="item.percent != 100" :percent="item.percent" :show-info="false" style="height:2px" />
              </div>
            </div>
          </a-card>
        </a-col>

        <a-col :span="8">
          <a-card title="英文字幕">
            <a-upload-dragger name="file" accept=".srt,.vtt" :multiple="true" :show-upload-list="false"
              :customRequest="handleChangeEn">
              <p class="ant-upload-drag-icon"><a-icon type="inbox" /> 上传英文字幕</p>
            </a-upload-dragger>

            <div style="margin-top: 10px;margin-bottom: 10px">
              <a-card>
                <a-row type="flex">
                  <a-statistic title="总计" :value="fileEnList.length" />
                  <a-statistic title="正在上传" :value="computedUploadEning" :style="{ margin: '0 32px' }"
                    :value-style="{ color: '#cf1322' }" />
                </a-row>
              </a-card>
            </div>

            <div style="max-height: 220px; overflow-y: auto;">
              <div v-for="(item, index) in fileEnList" :key="index" style="margin-bottom: 5px">
                <div style="display: flex; justify-content: space-between">
                  <div>
                    <a-icon type="loading" v-if="item.percent != 100" style="margin-right: 10px" />
                    <a-icon type="link" v-if="item.percent == 100" style="margin-right: 10px" />
                    <a-icon type="close-circle" v-if="item.status === 'error'" style="margin-right: 10px; color: #f5222d" />
                    {{ item.name }}
                  </div>
                  <a-icon type="delete" @click.stop="clickDelete(index, 3)" />
                </div>
                <a-progress v-if="item.percent != 100" :percent="item.percent" :show-info="false" style="height:2px" />
              </div>
            </div>
          </a-card>
        </a-col>

        <a-col :span="8">
          <a-card title="日语字幕">
            <a-upload-dragger name="file" accept=".srt,.vtt" :multiple="true" :show-upload-list="false"
              :customRequest="handleChangeJa">
              <p class="ant-upload-drag-icon"><a-icon type="inbox" /> 上传日语字幕</p>
            </a-upload-dragger>

            <div style="margin-top: 10px;margin-bottom: 10px">
              <a-card>
                <a-row type="flex">
                  <a-statistic title="总计" :value="fileJaList.length" />
                  <a-statistic title="正在上传" :value="computedUploadJaing" :style="{ margin: '0 32px' }"
                    :value-style="{ color: '#cf1322' }" />
                </a-row>
              </a-card>
            </div>

            <div style="max-height: 220px; overflow-y: auto;">
              <div v-for="(item, index) in fileJaList" :key="index" style="margin-bottom: 5px">
                <div style="display: flex; justify-content: space-between">
                  <div>
                    <a-icon type="loading" v-if="item.percent != 100" style="margin-right: 10px" />
                    <a-icon type="link" v-if="item.percent == 100" style="margin-right: 10px" />
                    <a-icon type="close-circle" v-if="item.status === 'error'" style="margin-right: 10px; color: #f5222d" />
                    {{ item.name }}
                  </div>
                  <a-icon type="delete" @click.stop="clickDelete(index, 4)" />
                </div>
                <a-progress v-if="item.percent != 100" :percent="item.percent" :show-info="false" style="height:2px" />
              </div>
            </div>
          </a-card>
        </a-col>
      </a-row>

      <!-- 第二行：印尼字幕、葡语字幕、西语字幕 -->
      <a-row :gutter="16" style="margin-top: 16px;">
        <a-col :span="8">
          <a-card title="印尼字幕">
            <a-upload-dragger name="file" accept=".srt,.vtt" :multiple="true" :show-upload-list="false"
              :customRequest="handleChangeId">
              <p class="ant-upload-drag-icon"><a-icon type="inbox" /> 上传印尼字幕</p>
            </a-upload-dragger>

            <div style="margin-top: 10px;margin-bottom: 10px">
              <a-card>
                <a-row type="flex">
                  <a-statistic title="总计" :value="fileIdList.length" />
                  <a-statistic title="正在上传" :value="computedUploadIding" :style="{ margin: '0 32px' }"
                    :value-style="{ color: '#cf1322' }" />
                </a-row>
              </a-card>
            </div>

            <div style="max-height: 220px; overflow-y: auto;">
              <div v-for="(item, index) in fileIdList" :key="index" style="margin-bottom: 5px">
                <div style="display: flex; justify-content: space-between">
                  <div>
                    <a-icon type="loading" v-if="item.percent != 100" style="margin-right: 10px" />
                    <a-icon type="link" v-if="item.percent == 100" style="margin-right: 10px" />
                    <a-icon type="close-circle" v-if="item.status === 'error'" style="margin-right: 10px; color: #f5222d" />
                    {{ item.name }}
                  </div>
                  <a-icon type="delete" @click.stop="clickDelete(index, 5)" />
                </div>
                <a-progress v-if="item.percent != 100" :percent="item.percent" :show-info="false" style="height:2px" />
              </div>
            </div>
          </a-card>
        </a-col>

        <a-col :span="8">
          <a-card title="葡语字幕">
            <a-upload-dragger name="file" accept=".srt,.vtt" :multiple="true" :show-upload-list="false"
              :customRequest="handleChangePt">
              <p class="ant-upload-drag-icon"><a-icon type="inbox" /> 上传葡语字幕</p>
            </a-upload-dragger>

            <div style="margin-top: 10px;margin-bottom: 10px">
              <a-card>
                <a-row type="flex">
                  <a-statistic title="总计" :value="filePtList.length" />
                  <a-statistic title="正在上传" :value="computedUploadPting" :style="{ margin: '0 32px' }"
                    :value-style="{ color: '#cf1322' }" />
                </a-row>
              </a-card>
            </div>

            <div style="max-height: 220px; overflow-y: auto;">
              <div v-for="(item, index) in filePtList" :key="index" style="margin-bottom: 5px">
                <div style="display: flex; justify-content: space-between">
                  <div>
                    <a-icon type="loading" v-if="item.percent != 100" style="margin-right: 10px" />
                    <a-icon type="link" v-if="item.percent == 100" style="margin-right: 10px" />
                    <a-icon type="close-circle" v-if="item.status === 'error'" style="margin-right: 10px; color: #f5222d" />
                    {{ item.name }}
                  </div>
                  <a-icon type="delete" @click.stop="clickDelete(index, 6)" />
                </div>
                <a-progress v-if="item.percent != 100" :percent="item.percent" :show-info="false" style="height:2px" />
              </div>
            </div>
          </a-card>
        </a-col>

        <a-col :span="8">
          <a-card title="西语字幕">
            <a-upload-dragger name="file" accept=".srt,.vtt" :multiple="true" :show-upload-list="false"
              :customRequest="handleChangeEs">
              <p class="ant-upload-drag-icon"><a-icon type="inbox" /> 上传西语字幕</p>
            </a-upload-dragger>

            <div style="margin-top: 10px;margin-bottom: 10px">
              <a-card>
                <a-row type="flex">
                  <a-statistic title="总计" :value="fileEsList.length" />
                  <a-statistic title="正在上传" :value="computedUploadEsing" :style="{ margin: '0 32px' }"
                    :value-style="{ color: '#cf1322' }" />
                </a-row>
              </a-card>
            </div>

            <div style="max-height: 220px; overflow-y: auto;">
              <div v-for="(item, index) in fileEsList" :key="index" style="margin-bottom: 5px">
                <div style="display: flex; justify-content: space-between">
                  <div>
                    <a-icon type="loading" v-if="item.percent != 100" style="margin-right: 10px" />
                    <a-icon type="link" v-if="item.percent == 100" style="margin-right: 10px" />
                    <a-icon type="close-circle" v-if="item.status === 'error'" style="margin-right: 10px; color: #f5222d" />
                    {{ item.name }}
                  </div>
                  <a-icon type="delete" @click.stop="clickDelete(index, 7)" />
                </div>
                <a-progress v-if="item.percent != 100" :percent="item.percent" :show-info="false" style="height:2px" />
              </div>
            </div>
          </a-card>
        </a-col>
      </a-row>

      <!-- <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
        <img alt="example" style="width: 100%" :src="previewImage" />
      </a-modal> -->
      <a-modal v-model:visible="previewVisible" width="720px" @cancel="handlePreviewClose">
        <div v-if="showVideo" style="position: relative; width: 100%; border-radius: 8px;">
          <video ref="videoPlayer" class="video-js vjs-default-skin" controls preload="auto"
            style="width: 100%; height: 720px;"></video>
          <div class="subtitle-overlay" ref="subtitleOverlay"></div>
        </div>
        <!-- <a-select v-model="selectedLanguage" style="margin: 8px 0; width: 120px" @change="onLanguageChange">
          <a-select-option value="zh" v-if="subtitleZhUrl">中文</a-select-option>
          <a-select-option value="en" v-if="subtitleEnUrl">英文</a-select-option>
          <a-select-option value="ja" v-if="subtitleJaUrl">日文</a-select-option>
        </a-select> -->
      </a-modal>
    </a-spin>
  </a-modal>
</template>

<script>

import { importData } from '@/api/video/gather'
import UploadFileToVOD from "@/api/vod";
import videojs from 'video.js'
import 'video.js/dist/video-js.css'
import UploadFileToVODFile from "@/api/UploadFileToVOD";
import axios from 'axios'
export default {
  name: 'ImportExcel',
  props: {
  },
  components: {
  },
  data() {

    return {
      title: '导入',
      open: false,
      uploadStatus: '',
      previewImage: '',
      fileList: [],
      fileZhList: [],
      fileEnList: [],
      fileJaList: [],
      // 是否禁用上传
      uploading: false,
      previewVisible: false,
      updateSupport: 0,
      id: '',
      previewVisible: false,
      showVideo: false,
      previewUrl: '',
      subtitleZhUrl: '',
      subtitleEnUrl: '',
      subtitleJaUrl: '',
      uniqueKey: 0, // 控制 video 销毁和重建
      subtitles: [],
      // selectedLanguage: 'zh', // 默认中文
      allSubtitles: {
        zh: [],
        en: [],
        ja: [],
      },
      subtitleTimer: null,

      fileIdList: [],
      filePtList: [],
      fileEsList: [],

      subtitleIdUrl: '',
      subtitlePtUrl: '',
      subtitleEsUrl: '',
    }

  },

  filters: {
  },
  created() {
  },
  computed: {
    // computedUploadVideoing() {
    //   return this.fileList.filter(i => i.percent !== 100 && !i.url).length;
    // },
    computedUploadVideoing() {
      if (this.fileList.length > 0) {
        return this.fileList.filter(i => {
          return i.percent != 100 && i.url === ''
        }).length;
      } else {
        return 0;
      }
    },
    computedUploadZhing() {
      if (this.fileZhList.length > 0) {
        return this.fileZhList.filter(i => {
          return i.percent != 100 && i.url === ''
        }).length;
      } else {
        return 0;
      }
    },
    computedUploadEning() {
      if (this.fileEnList.length > 0) {
        return this.fileEnList.filter(i => {
          return i.percent != 100 && i.url === ''
        }).length;
      } else {
        return 0;
      }
    },
    computedUploadJaing() {
      if (this.fileJaList.length > 0) {
        return this.fileJaList.filter(i => {
          return i.percent != 100 && i.url === ''
        }).length;
      } else {
        return 0;
      }
    },

    computedUploadIding() {
      if (this.fileIdList.length > 0) {
        return this.fileIdList.filter(i => {
          return i.percent != 100 && i.url === ''
        }).length;
      } else {
        return 0;
      }
    },

    computedUploadPting() {
      if (this.filePtList.length > 0) {
        return this.filePtList.filter(i => {
          return i.percent != 100 && i.url === ''
        }).length;
      } else {
        return 0;
      }
    },

    computedUploadEsing() {
      if (this.fileEsList.length > 0) {
        return this.fileEsList.filter(i => {
          return i.percent != 100 && i.url === ''
        }).length;
      } else {
        return 0;
      }
    },
  },
  watch: {
  },
  methods: {
    async loadSrt(url) {
      const res = await fetch(url)
      const text = await res.text()
      return this.parseSrt(text)
    },

    parseSrt(srt) {
      const pattern = /\d+\s+(\d{2}:\d{2}:\d{2},\d{3})\s-->\s(\d{2}:\d{2}:\d{2},\d{3})\s+([\s\S]*?)(?=\n\d+\s+\d{2}|\n*$)/g
      const result = []
      let match
      while ((match = pattern.exec(srt)) !== null) {
        result.push({
          start: this.toSeconds(match[1]),
          end: this.toSeconds(match[2]),
          text: match[3].trim().replace(/\n/g, '<br>')
        })
      }
      return result
    },

    toSeconds(timeStr) {
      const [h, m, s] = timeStr.replace(',', '.').split(':')
      return parseFloat(h) * 3600 + parseFloat(m) * 60 + parseFloat(s)
    },

    startSubtitleSync() {
      if (this.subtitleTimer) {
        clearInterval(this.subtitleTimer)
      }

      this.subtitleTimer = setInterval(() => {
        if (!this.player || this.subtitles.length === 0) return

        const currentTime = this.player.currentTime()
        const current = this.subtitles.find(
          s => s.start <= currentTime && s.end >= currentTime
        )
        this.$refs.subtitleOverlay.innerHTML = current ? current.text : ''
      }, 300)
    },

    stopSubtitleSync() {
      if (this.subtitleTimer) {
        clearInterval(this.subtitleTimer)
        this.subtitleTimer = null
      }
    },
    async openPreview(item) {
      this.showVideo = false

      this.$nextTick(async () => {
        this.previewUrl = item.url
        const serial = this.getSerialNumber(item.name);
        console.log("serial" + serial)

        const zh = this.fileZhList.find(f => this.getSerialNumber(f.name) === serial)
        const en = this.fileEnList.find(f => this.getSerialNumber(f.name) === serial)
        const ja = this.fileJaList.find(f => this.getSerialNumber(f.name) === serial)

        const id = this.fileIdList.find(f => this.getSerialNumber(f.name) === serial)
        const pt = this.filePtList.find(f => this.getSerialNumber(f.name) === serial)
        const es = this.fileEsList.find(f => this.getSerialNumber(f.name) === serial)

        this.subtitleZhUrl = zh ? zh.url : ''
        this.subtitleEnUrl = en ? en.url : ''
        this.subtitleJaUrl = ja ? ja.url : ''

        this.subtitleIdUrl = id ? id.url : ''
        this.subtitlePtUrl = pt ? pt.url : ''
        this.subtitleEsUrl = es ? es.url : ''

        this.showVideo = true
        this.previewVisible = true
        await this.$nextTick()
        this.initVideoPlayer()
      })
    },


    async loadAndParseAllSubtitles() {
      if (this.subtitleZhUrl) {
        const zhData = await fetch(this.subtitleZhUrl).then(res => res.text())
        this.zhSubs = this.parseSrt(zhData)
      } else {
        this.zhSubs = []
      }

      if (this.subtitleEnUrl) {
        const enData = await fetch(this.subtitleEnUrl).then(res => res.text())
        this.enSubs = this.parseSrt(enData)
      } else {
        this.enSubs = []
      }

      if (this.subtitleJaUrl) {
        const jaData = await fetch(this.subtitleJaUrl).then(res => res.text())
        this.jaSubs = this.parseSrt(jaData)
      } else {
        this.jaSubs = []
      }

      if (this.subtitleIdUrl) {
        const idData = await fetch(this.subtitleIdUrl).then(res => res.text())
        this.idSubs = this.parseSrt(idData)
      } else {
        this.idSubs = []
      }

      if (this.subtitlePtUrl) {
        const ptData = await fetch(this.subtitlePtUrl).then(res => res.text())
        this.ptSubs = this.parseSrt(ptData)
      } else {
        this.ptSubs = []
      }

      if (this.subtitleEsUrl) {
        const esData = await fetch(this.subtitleEsUrl).then(res => res.text())
        this.esSubs = this.parseSrt(esData)
      } else {
        this.esSubs = []
      }
    },

    initVideoPlayer() {
      if (this.player) {
        this.player.dispose()
        this.player = null
      }

      this.player = videojs(this.$refs.videoPlayer, {
        autoplay: true,
        controls: true,
        preload: 'auto',
        sources: [{ src: this.previewUrl, type: 'video/mp4' }],
      })

      // 关闭自带字幕显示
      this.player.ready(() => {
        const tracks = this.player.textTracks()
        for (let i = 0; i < tracks.length; i++) {
          tracks[i].mode = 'disabled'
        }
      })

      // 先等待字幕加载完毕再绑定事件
      this.loadAndParseAllSubtitles().then(() => {
        this.player.on('timeupdate', () => {
          if (!this.zhSubs || !this.enSubs || !this.jaSubs || !this.idSubs || !this.ptSubs || !this.esSubs) return
          const currentTime = this.player.currentTime()
          const zhText = this.getSubtitleTextAtTime(this.zhSubs, currentTime)
          const enText = this.getSubtitleTextAtTime(this.enSubs, currentTime)
          const jaText = this.getSubtitleTextAtTime(this.jaSubs, currentTime)

          const idText = this.getSubtitleTextAtTime(this.idSubs, currentTime)
          const ptText = this.getSubtitleTextAtTime(this.ptSubs, currentTime)
          const esText = this.getSubtitleTextAtTime(this.esSubs, currentTime)
          this.$refs.subtitleOverlay.innerHTML = [zhText, enText, jaText, idText, ptText, esText].filter(Boolean).join('<br>')
        })
      })
    },

    getSubtitleTextAtTime(subs, time) {
      if (!subs || subs.length === 0) return ''
      for (const sub of subs) {
        if (time >= sub.start && time <= sub.end) return sub.text
      }
      return ''
    },
    // 切换语言
    // initVideoPlayer() {
    //   if (this.player) {
    //     this.player.dispose()
    //     this.player = null
    //   }

    //   this.player = videojs(this.$refs.videoPlayer, {
    //     autoplay: true,
    //     controls: true,
    //     preload: 'auto',
    //     sources: [{
    //       src: this.previewUrl,
    //       type: 'video/mp4',
    //     }]
    //   })

    //   this.subtitles = []
    //   this.allSubtitles = { zh: [], en: [], ja: [] }

    //   const loadAll = []

    //   if (this.subtitleZhUrl) {
    //     loadAll.push(this.loadSrt(this.subtitleZhUrl).then(s => this.allSubtitles.zh = s))
    //   }
    //   if (this.subtitleEnUrl) {
    //     loadAll.push(this.loadSrt(this.subtitleEnUrl).then(s => this.allSubtitles.en = s))
    //   }
    //   if (this.subtitleJaUrl) {
    //     loadAll.push(this.loadSrt(this.subtitleJaUrl).then(s => this.allSubtitles.ja = s))
    //   }

    //   Promise.all(loadAll).then(() => {
    //     // 默认选中语言
    //     if (this.allSubtitles.zh.length) {
    //       this.selectedLanguage = 'zh'
    //     } else if (this.allSubtitles.en.length) {
    //       this.selectedLanguage = 'en'
    //     } else if (this.allSubtitles.ja.length) {
    //       this.selectedLanguage = 'ja'
    //     }

    //     this.subtitles = this.allSubtitles[this.selectedLanguage] || []
    //     this.startSubtitleSync()
    //   })
    // },

    // onLanguageChange(lang) {
    //   this.subtitles = this.allSubtitles[lang] || []
    // },


    handlePreviewClose() {
      this.previewVisible = false
      this.showVideo = false
      this.stopSubtitleSync()
      if (this.player) {
        this.player.pause()
        this.player.dispose()
        this.player = null
      }
    },
    getBaseName(filename) {
      if (!filename || typeof filename !== 'string') {
        return ''
      }
      // 先取第一个 '.' 之前的部分
      const nameWithoutExt = filename.split('.')[0]
      // 如果包含 '-'，取 '-' 分割后的第2部分，否则就直接返回
      if (nameWithoutExt.includes('-')) {
        const parts = nameWithoutExt.split('-')
        return parts[1] || nameWithoutExt  // 防止只有一个 '-'，取不到索引1时返回原始
      }
      return nameWithoutExt
    },


    beforeDestroy() {
      this.stopSubtitleSync()
      if (this.player) {
        this.player.dispose()
        this.player = null
      }
    },

    clickDelete(index, num) {
      let that = this;
      this.$confirm({
        content: '是否确认删除呢?',
        centered: true,
        onOk() {
          if (num == 1) {
            that.fileList.splice(index, 1)
          }

          if (num == 2) {
            that.fileZhList.splice(index, 1)
          }

          if (num == 3) {
            that.fileEnList.splice(index, 1)
          }
          if (num == 4) {
            that.fileJaList.splice(index, 1)
          }

          if (num == 5) {
            that.fileIdList.splice(index, 1)
          }
          if (num == 6) {
            that.filePtList.splice(index, 1)
          }
          if (num == 7) {
            that.fileEsList.splice(index, 1)
          }
        },
        onCancel() {
          // that.open = false
          // that.fileList = [];
          // that.fileEnList = [];
          // that.fileZhList = [];
          // that.fileJaList = [];
        }
      })

    },

    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    handleCancel() {
      this.previewVisible = false;
    },

    changeFile(info) {
      console.log("11111111111111111111111")
      console.log(info)
      // this.fileList.push({
      //   uid:info.file.uid,
      //   name:info.file.name,
      //   status: 'done',
      //   url:'',
      //   percent:0
      // })
    },
    handleChange(info) {
      console.log('nnnnnn')
      console.log(info)
      this.fileList.push({
        uid: info.file.uid,
        name: info.file.name,
        status: 'done',
        url: '',
        percent: 0
      })
      console.log(this.fileList)
      let that = this
      // that.form.videoUrl = ""
      let findIndex = that.fileList.findIndex(i => i.uid == info.file.uid);
      console.log('+_------' + findIndex)
      new UploadFileToVOD([info.file], {
        success: function (fileName) {

          if (findIndex != -1) {

            that.fileList[findIndex].url = fileName[0];
            that.$set(that.fileList[findIndex], 'url', fileName[0]);
          }
        },
        vProgress: function (val) {
          if (findIndex != -1) {
            that.fileList[findIndex].percent = val * 100;
            that.$set(that.fileList[findIndex], 'percent', val * 100);
          }
        },
        fileId: function (val) {
          if (findIndex != -1) {
            that.fileList[findIndex].fileId = val;
            that.$set(that.fileList[findIndex], 'fileId', val);
            console.log(999999999)
            console.log(val)
          }
        }
      });
    },

    handleChangeZh(info) {
      let that = this;
      this.fileZhList.push({
        uid: info.file.uid,
        name: info.file.name,
        status: 'uploading',
        url: '',
        percent: 0
      })
      let findIndex = that.fileZhList.findIndex(i => i.uid == info.file.uid);

      let FormDatas = new FormData();
      FormDatas.append('file', info.file)
      //      //        url: "https://web.frameflash.com/admin-api/common/local/file/uploadCos", // 接口地址

      axios({
        method: 'post',
        url: "https://admin.dramagostudio.com/admin-api/common/local/file/uploadCos", // 接口地址
        data: FormDatas,
        // 请求配置按需配置即可
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'multipart/form-data;boundary=' + new Date().getTime()
        },
        // 上传进度
        onUploadProgress: (progressEvent) => {
          let num = progressEvent.loaded / progressEvent.total * 100 | 0 // 计算进度
          console.log(num)
          if (findIndex != -1) {
            that.fileZhList[findIndex].percent = num;
            that.$set(that.fileZhList[findIndex], 'percent', num);
          }
        }
      }).then((res) => {
        console.log('res---------')
        console.log(res)
        console.log(findIndex)
        if (findIndex != -1) {
          // url
          that.fileZhList[findIndex].url = res.data.data.mediaUrl;
          that.$set(that.fileZhList[findIndex], 'url', res.data.data.mediaUrl);
          that.$set(that.fileZhList[findIndex], 'percent', 100);
          that.$set(that.fileZhList[findIndex], 'status', 'done');
        }
      }).catch(() => {
        if (findIndex != -1) {
          that.fileZhList[findIndex].status = 'error';
          that.$set(that.fileZhList[findIndex], 'status', 'error');
        }
      });
      console.log(info)
    },

    handleChangeEn(info) {
      let that = this;

      this.fileEnList.push({
        uid: info.file.uid,
        name: info.file.name,
        status: 'uploading',
        url: '',
        percent: 0
      })

      let findIndex = that.fileEnList.findIndex(i => i.uid == info.file.uid);

      let FormDatas = new FormData();
      FormDatas.append('file', info.file)
      //        url: "https://web.frameflash.com/admin-api/common/local/file/uploadCos", // 接口地址

      axios({
        method: 'post',
        url: "https://admin.dramagostudio.com/admin-api/common/local/file/uploadCos", // 接口地址
        data: FormDatas,
        // 请求配置按需配置即可
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'multipart/form-data;boundary=' + new Date().getTime()
        },
        // 上传进度
        onUploadProgress: (progressEvent) => {
          let num = progressEvent.loaded / progressEvent.total * 100 | 0 // 计算进度
          console.log(num)
          if (findIndex != -1) {
            that.fileEnList[findIndex].percent = num;
            that.$set(that.fileEnList[findIndex], 'percent', num);
          }
        }
      }).then((res) => {
        console.log('res---------')
        console.log(res)
        console.log(findIndex)
        if (findIndex != -1) {
          // url
          that.fileEnList[findIndex].url = res.data.data.mediaUrl;
          that.$set(that.fileEnList[findIndex], 'url', res.data.data.mediaUrl);
          that.$set(that.fileEnList[findIndex], 'percent', 100);
          that.$set(that.fileEnList[findIndex], 'status', 'done');
        }
      }).catch(() => {
        if (findIndex != -1) {
          that.fileEnList[findIndex].status = 'error';
          that.$set(that.fileEnList[findIndex], 'status', 'error');
        }
      });

    },
    handleChangeJa(info) {
      let that = this;

      this.fileJaList.push({
        uid: info.file.uid,
        name: info.file.name,
        status: 'uploading',
        url: '',
        percent: 0
      })

      let findIndex = that.fileJaList.findIndex(i => i.uid == info.file.uid);

      let FormDatas = new FormData();
      FormDatas.append('file', info.file)
      //        url: "https://web.frameflash.com/admin-api/common/local/file/uploadCos", // 接口地址

      axios({
        method: 'post',
        url: "https://admin.dramagostudio.com/admin-api/common/local/file/uploadCos", // 接口地址
        data: FormDatas,
        // 请求配置按需配置即可
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'multipart/form-data;boundary=' + new Date().getTime()
        },
        // 上传进度
        onUploadProgress: (progressEvent) => {
          let num = progressEvent.loaded / progressEvent.total * 100 | 0 // 计算进度
          console.log(num)
          if (findIndex != -1) {
            that.fileJaList[findIndex].percent = num;
            that.$set(that.fileJaList[findIndex], 'percent', num);
          }
        }
      }).then((res) => {
        if (findIndex != -1) {
          // url
          that.fileJaList[findIndex].url = res.data.data.mediaUrl;
          that.$set(that.fileJaList[findIndex], 'url', res.data.data.mediaUrl);
          that.$set(that.fileJaList[findIndex], 'percent', 100);
          that.$set(that.fileJaList[findIndex], 'status', 'done');
        }
      }).catch(() => {
        if (findIndex != -1) {
          that.fileJaList[findIndex].status = 'error';
          that.$set(that.fileJaList[findIndex], 'status', 'error');
        }
      });
    },


    handleChangeId(info) {
      let that = this;

      this.fileIdList.push({
        uid: info.file.uid,
        name: info.file.name,
        status: 'uploading',
        url: '',
        percent: 0
      })

      let findIndex = that.fileIdList.findIndex(i => i.uid == info.file.uid);

      let FormDatas = new FormData();
      FormDatas.append('file', info.file)
      //        url: "https://web.frameflash.com/admin-api/common/local/file/uploadCos", // 接口地址

      axios({
        method: 'post',
        url: "https://admin.dramagostudio.com/admin-api/common/local/file/uploadCos", // 接口地址
        data: FormDatas,
        // 请求配置按需配置即可
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'multipart/form-data;boundary=' + new Date().getTime()
        },
        // 上传进度
        onUploadProgress: (progressEvent) => {
          let num = progressEvent.loaded / progressEvent.total * 100 | 0 // 计算进度
          console.log(num)
          if (findIndex != -1) {
            that.fileIdList[findIndex].percent = num;
            that.$set(that.fileIdList[findIndex], 'percent', num);
          }
        }
      }).then((res) => {
        if (findIndex != -1) {
          // url
          that.fileIdList[findIndex].url = res.data.data.mediaUrl;
          that.$set(that.fileIdList[findIndex], 'url', res.data.data.mediaUrl);
          that.$set(that.fileIdList[findIndex], 'percent', 100);
          that.$set(that.fileIdList[findIndex], 'status', 'done');
        }
      }).catch(() => {
        if (findIndex != -1) {
          that.fileIdList[findIndex].status = 'error';
          that.$set(that.fileIdList[findIndex], 'status', 'error');
        }
      });
    },
    handleChangePt(info) {
      let that = this;

      this.filePtList.push({
        uid: info.file.uid,
        name: info.file.name,
        status: 'uploading',
        url: '',
        percent: 0
      })

      let findIndex = that.filePtList.findIndex(i => i.uid == info.file.uid);

      let FormDatas = new FormData();
      FormDatas.append('file', info.file)
      //        url: "https://web.frameflash.com/admin-api/common/local/file/uploadCos", // 接口地址

      axios({
        method: 'post',
        url: "https://admin.dramagostudio.com/admin-api/common/local/file/uploadCos", // 接口地址
        data: FormDatas,
        // 请求配置按需配置即可
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'multipart/form-data;boundary=' + new Date().getTime()
        },
        // 上传进度
        onUploadProgress: (progressEvent) => {
          let num = progressEvent.loaded / progressEvent.total * 100 | 0 // 计算进度
          console.log(num)
          if (findIndex != -1) {
            that.filePtList[findIndex].percent = num;
            that.$set(that.filePtList[findIndex], 'percent', num);
          }
        }
      }).then((res) => {
        if (findIndex != -1) {
          // url
          that.filePtList[findIndex].url = res.data.data.mediaUrl;
          that.$set(that.filePtList[findIndex], 'url', res.data.data.mediaUrl);
          that.$set(that.filePtList[findIndex], 'percent', 100);
          that.$set(that.filePtList[findIndex], 'status', 'done');
        }
      }).catch(() => {
        if (findIndex != -1) {
          that.filePtList[findIndex].status = 'error';
          that.$set(that.filePtList[findIndex], 'status', 'error');
        }
      });
    },
    handleChangeEs(info) {
      let that = this;

      this.fileEsList.push({
        uid: info.file.uid,
        name: info.file.name,
        status: 'uploading',
        url: '',
        percent: 0
      })

      let findIndex = that.fileEsList.findIndex(i => i.uid == info.file.uid);

      let FormDatas = new FormData();
      FormDatas.append('file', info.file)
      //        url: "https://web.frameflash.com/admin-api/common/local/file/uploadCos", // 接口地址

      axios({
        method: 'post',
        url: "https://admin.dramagostudio.com/admin-api/common/local/file/uploadCos", // 接口地址
        data: FormDatas,
        // 请求配置按需配置即可
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'multipart/form-data;boundary=' + new Date().getTime()
        },
        // 上传进度
        onUploadProgress: (progressEvent) => {
          let num = progressEvent.loaded / progressEvent.total * 100 | 0 // 计算进度
          console.log(num)
          if (findIndex != -1) {
            that.fileEsList[findIndex].percent = num;
            that.$set(that.fileEsList[findIndex], 'percent', num);
          }
        }
      }).then((res) => {
        if (findIndex != -1) {
          // url
          that.fileEsList[findIndex].url = res.data.data.mediaUrl;
          that.$set(that.fileEsList[findIndex], 'url', res.data.data.mediaUrl);
          that.$set(that.fileEsList[findIndex], 'percent', 100);
          that.$set(that.fileEsList[findIndex], 'status', 'done');
        }
      }).catch(() => {
        if (findIndex != -1) {
          that.fileEsList[findIndex].status = 'error';
          that.$set(that.fileEsList[findIndex], 'status', 'error');
        }
      });
    },
    /** 导入excel窗体关闭 */
    importExcelHandleCancel(e) {
      let that = this;
      if (this.fileList.length > 0 || this.fileEnList.length > 0 || this.fileZhList.length > 0 || this.fileJaList.length > 0 || this.fileIdList.length > 0 || this.filePtList.length > 0 || this.fileEsList.length > 0) {
        this.$confirm({
          content: '您上传的短剧/字幕文件尚未保存是否关闭?',
          centered: true,
          onOk() {
            that.open = false
            that.fileList = [];
            that.fileEnList = [];
            that.fileZhList = [];
            that.fileJaList = [];

            that.fileIdList = [];
            that.filePtList = [];
            that.fileEsList = [];
          },
          onCancel() {
            // that.open = false
            // that.fileList = [];
            // that.fileEnList = [];
            // that.fileZhList = [];
            // that.fileJaList = [];
          }
        })
      } else {
        this.open = false
        this.fileList = [];
        this.fileEnList = [];
        this.fileZhList = [];
        this.fileJaList = [];

        this.fileIdList = [];
        this.filePtList = [];
        this.fileEsList = [];
      }

      // // 关闭后刷新列表
      // this.$emit('ok')
    },
    /** 下载模板操作 */
    importTemplate() {
      this.download('/video/video-gather/importTemplate', {
        ...this.queryParams
      }, `gather_template_${new Date().getTime()}.xlsx`)
    },
    /** 导入excel窗体开启 */
    importExcelHandleOpen(e) {
      this.id = e;
      this.open = true
    },
    beforeUpload(file) {
      this.fileList = [file]
      return false
    },
    /** 导入excel */
    importExcelHandleChange() {
      if (this.fileList.length > 0) {
        if (this.computedUploadVideoing != 0) {
          this.$message.error("剧集文件还未上传完毕,请耐心等待")
          return;
        }
      }

      if (this.fileZhList.length > 0) {
        if (this.computedUploadZhing != 0) {
          this.$message.error("中文字幕文件还未上传完毕,请耐心等待")
          return;
        }
      }

      if (this.fileEnList.length > 0) {
        if (this.computedUploadEning != 0) {
          this.$message.error("英文字幕文件还未上传完毕,请耐心等待")
          return;
        }
      }

      if (this.fileJaList.length > 0) {
        if (this.computedUploadJaing != 0) {
          this.$message.error("日语字幕文件还未上传完毕,请耐心等待")
          return;
        }
      }

      if (this.fileIdList.length > 0) {
        if (this.computedUploadIding != 0) {
          this.$message.error("印尼字幕文件还未上传完毕,请耐心等待")
          return;
        }
      }

      if (this.filePtList.length > 0) {
        if (this.computedUploadPting != 0) {
          this.$message.error("葡语字幕文件还未上传完毕,请耐心等待")
          return;
        }
      }

      if (this.fileEsList.length > 0) {
        if (this.computedUploadEsing != 0) {
          this.$message.error("西语字幕文件还未上传完毕,请耐心等待")
          return;
        }
      }
        // 🔍 新增校验：检查 url 是否为空
      const allLists = [
        { list: this.fileList, type: "剧集" },
        { list: this.fileZhList, type: "中文字幕" },
        { list: this.fileEnList, type: "英文字幕" },
        { list: this.fileJaList, type: "日语字幕" },
        { list: this.fileIdList, type: "印尼字幕" },
        { list: this.filePtList, type: "葡语字幕" },
        { list: this.fileEsList, type: "西语字幕" }
      ];

      for (let { list, type } of allLists) {
        for (let file of list) {
          if (!file.url) {
            this.$message.error(`${type}文件 ${file.name} 未上传成功，请检查后重试`);
            return; // 有空 url，直接中断
          }
       }
      }

      this.uploading = true
      // const { fileList } = this
      // const formData = new FormData()
      // formData.append('file', fileList[0])
      // formData.append('updateSupport', this.updateSupport)

      let arrList = this.fileList.map(i => ({
        serialNumber: this.getSerialNumber(i.name),
        videoUrl: i.url,
        fileId: i.fileId,
        videoId: this.id
      }))
      let enList = this.fileEnList.map(i => ({
        serialNumber: this.getSerialNumber(i.name),
        subtitleEn: i.url,
        videoId: this.id,
      }));
      let zhList = this.fileZhList.map(i => ({
        serialNumber: this.getSerialNumber(i.name),
        subtitleCn: i.url,
        videoId: this.id,
      }))
      let jaList = this.fileJaList.map(i => ({
        serialNumber: this.getSerialNumber(i.name),
        subtitleJa: i.url,
        videoId: this.id,
      }))

      let idList = this.fileIdList.map(i => ({
        serialNumber: this.getSerialNumber(i.name),
        subtitleId: i.url,
        videoId: this.id,
      }));
      let ptList = this.filePtList.map(i => ({
        serialNumber: this.getSerialNumber(i.name),
        subtitlePt: i.url,
        videoId: this.id,
      }))
      let esList = this.fileEsList.map(i => ({
        serialNumber: this.getSerialNumber(i.name),
        subtitleEs: i.url,
        videoId: this.id,
      }))
      let newArrData = {
        arrList: arrList,
        enList: enList,
        zhList: zhList,
        jaList: jaList,

        idList: idList,
        ptList: ptList,
        esList: esList
      }
      importData(JSON.stringify(newArrData)).then(response => {
        if (response.code == 1 || response.code == 20001) {
          this.fileList = [];
          this.fileEnList = [];
          this.fileZhList = [];
          this.fileJaList = [];

          this.fileIdList = [];
          this.filePtList = [];
          this.fileEsList = [];
          this.$message.success(response.message)
          this.open = false
          this.$emit('ok')
        } else {
          this.$message.error(response.message)
          return
        }

      }).finally(() => {
        this.uploading = false
        this.$emit('ok')
      })
    },
    getSerialNumber(filename) {
      const nameWithoutExt = filename.substring(0, filename.lastIndexOf("."));
      const parts = nameWithoutExt.split(".");
      // 取最后一个纯数字的部分
      for (let i = parts.length - 1; i >= 0; i--) {
        if (/^\d+$/.test(parts[i])) {
          return parts[i];
        }
      }
      return nameWithoutExt; // 没找到数字就返回原名
    },
    handleCheckedUpdateSupport() {
      this.updateSupport = this.updateSupport === 0 ? 1 : 0
    },
    handleRemove() {
      this.fileList = []
      this.uploading = false
    },
    handleRemoveZh() {
      this.fileList = []
      this.fileZhList = [];
      this.uploading = false
    },
    handleRemoveEn() {
      this.fileEnList = [];
      this.fileList = []
      this.uploading = false
    },
    handleRemoveJa() {
      this.fileJaList = [];
      this.fileList = []
      this.uploading = false
    },

    handleRemoveId() {
      this.fileIdList = [];
      this.fileList = []
      this.uploading = false
    },

    handleRemovePt() {
      this.filePtList = [];
      this.fileList = []
      this.uploading = false
    },

    handleRemoveES() {
      this.fileEsList = [];
      this.fileList = []
      this.uploading = false
    },
  }
}
</script>
<style scoped>
.subtitle-overlay {
  position: absolute;
  bottom: 80px;
  width: 100%;
  text-align: center;
  font-size: 18px;
  color: white;
  text-shadow: 2px 2px 8px black;
  pointer-events: none;
}
</style>
